import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchVaga } from '../api';
import { useNavigate } from 'react-router-dom';
import TypographyDetail from './TypographyDetail'; 
import LocationOnIcon from '@mui/icons-material/LocationOn'; 
import GroupIcon from '@mui/icons-material/Group'; 
import AccessTimeIcon from '@mui/icons-material/AccessTime'; 
import Typography from '@mui/material/Typography'; 
import Button from '@mui/material/Button'; 
import WhatsAppIcon from '@mui/icons-material/WhatsApp'; 
import EmailIcon from '@mui/icons-material/Email'; 
import CloseIcon from '@mui/icons-material/Close'; 
import ShareFloatButton from "./ShareFloatButton"; 
import JobInactive from "./JobInactive";
import CircularIndeterminate from './CircularIndeterminate';

export default function VagaDetalhes() {
  const { code } = useParams();
  const [vaga, setVaga] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const loadVaga = async () => {
      setLoading(true);
      setNotFound(false);

      try {
        const vaga = await fetchVaga(code);

        if (!vaga) {
          setNotFound(true);
          return;
        }

        setVaga(vaga);
      } catch (err) {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    loadVaga();
  }, [code]);

  if (loading) return <CircularIndeterminate />;

  if (notFound) return <JobInactive />;

  if (!vaga?.visivel) {
    return <JobInactive title={vaga?.titulo} />;
  }

  const assunto = encodeURIComponent(`Candidatura - Vaga ${vaga.cod_vaga}`);
  const numero = "5516994653317";
  const email = "vagasreconect@gmail.com";

  const corpo = encodeURIComponent(
    `Olá! Tenho interesse na vaga ${vaga.cod_vaga}.\n` +
    `Título: ${vaga.titulo}\n` +
    `Cidade: ${vaga.cidade}\n` +
    `Bairro: ${vaga.bairro}\n\n` +
    `Pode me passar mais detalhes?`
  );

  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${assunto}&body=${corpo}`;
  const whatsappUrl = `https://wa.me/${numero}?text=${corpo}`;

  const daysSince = (isoDate) => {
    if (!isoDate) return null;
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.floor((Date.now() - new Date(isoDate).getTime()) / msPerDay);
  };

  return (
    <div className="show d-block" tabIndex="-1">
      <div className="row">
        <h5>{vaga.titulo}</h5>
        <h6>{vaga.funcao} - {vaga.seguimento}</h6>
      </div>

      <div className="info-row" style={{ justifyContent: "space-between" }}>
        <span><AccessTimeIcon color="warning" /> Publicada há {daysSince(vaga.criado_em)} dias</span>
        <span><GroupIcon color="primary" /> {vaga.quantidade_vagas} {vaga.quantidade_vagas > 1 ? "vagas" : "vaga"}</span>
        <span><LocationOnIcon color="error" />{vaga.bairro}, {vaga.cidade}</span>
      </div>

      <ShareFloatButton />
      <hr />

      <div className="modal-body">
        <Typography style={{ fontWeight: "bolder", textTransform: "uppercase", fontSize: "18px" }} gutterBottom>DADOS</Typography>

        {vaga.dados_vaga.split('\n').map((linha, i) => (
          <Typography key={i} component="div" style={{ display: "flex", alignItems: "flex-start" }}>
            <span style={{ color: "#62BFEF", marginRight: 6 }}>•</span>
            <span>{linha}</span>
          </Typography>
        ))}

        <br />
        <TypographyDetail type="Benefícios" text={vaga.beneficios} />
        <br />
        <TypographyDetail type="Responsabilidades" text={vaga.responsabilidade} />
        <br />
        <TypographyDetail type="Requisitos" text={vaga.requisitos} />
        <br />
        <TypographyDetail type="Empresa" text={vaga.empresa} />
        <br />
        <TypographyDetail type="Código da Vaga" text={vaga.cod_vaga} />
        <br />
      </div>

      <div className="pb-4">
        <div className="row">
          <div className="col-xs-12 col-md-4 mb-2">
            <Button
              startIcon={<WhatsAppIcon />}
              component="a"
              href={whatsappUrl}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              color="success"
              style={{ width: "-webkit-fill-available" }}
            >
              Enviar currículo via WhatsApp
            </Button>
          </div>
          <div className="col-xs-12 col-md-4 mb-2">
            <Button
              startIcon={<EmailIcon />}
              component="a"
              href={gmailUrl}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              color="primary"
              style={{ width: "-webkit-fill-available" }}
            >
              Enviar currículo via E-mail
            </Button>
          </div>
          <div className="col-xs-12 col-md-4 mb-2">
            <Button
              startIcon={<CloseIcon />}
              variant="outlined"
              color="error"
              onClick={() => navigate("/")}
              style={{ width: "-webkit-fill-available" }}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>

    </div>
  );
}
